import dayjs from 'dayjs'

import { useLineChart } from '@/pages/ui/line-chart/use-line-chart'

import type { ResGetCaseProcessingTimeTrendItem } from '@/lib/queries/case/public/trend/processing-time/types'

export const InquiryDateTrendChartTooltip: React.FC = () => {
  const { activeIndex, data } = useLineChart()

  if (activeIndex === null) {
    return null
  }

  const activeData = data[activeIndex] as ResGetCaseProcessingTimeTrendItem | null

  if (!activeData) {
    return null
  }

  return (
    <div>
      <div className="text-sm font-medium text-foreground">
        {dayjs(activeData.caseInquiryDate).format('MMM D, YYYY')}
      </div>
    </div>
  )
}
